import React, { Dispatch, useEffect, useState } from "react";
import { IMutator } from "sonobello.utilities.react";
import { Nullable } from "sonobello.utilities.react.mui";

import { EnhancedAppointment } from "../../../../../Models/Appointment";
import { BaseDispositionConfirmationForm, IBaseDispositionConfirmationFormProps } from "./ConfirmationForm";

export interface IMedicalEscalationConfirmationFormProps extends IBaseDispositionConfirmationFormProps {
  /** The customer that is being considered for the session's disposition. */
  onConfirmed: Dispatch<EnhancedAppointment>;
  /** The component containing the escalation form that should be rendered. */
  MedicalEscalationAppointmentPicker: React.FC<IMutator<EnhancedAppointment>>;
}

/** An extension of the confirmation form to be used when the disposition type is 'Medical Escalation'. */
export const MedicalEscalationConfirmationForm: React.FC<IMedicalEscalationConfirmationFormProps> = ({
  isConfirmed,
  onConfirmed,
  setConfirmDisabledReason,
  MedicalEscalationAppointmentPicker,
  ...rest
}) => {
  const [medicalEscalationAppointment, setMedicalEscalationAppointment] = useState<Nullable<EnhancedAppointment>>(null);

  useEffect(() => {
    setConfirmDisabledReason(medicalEscalationAppointment ? null : "An appointment must be selected.");
  }, [medicalEscalationAppointment]);
  useEffect(() => {
    if (!isConfirmed || !medicalEscalationAppointment) return;
    onConfirmed(medicalEscalationAppointment);
  }, [isConfirmed, onConfirmed, medicalEscalationAppointment]);

  return (
    <BaseDispositionConfirmationForm
      {...rest}
      isConfirmed={isConfirmed}
      setConfirmDisabledReason={setConfirmDisabledReason}
    >
      <MedicalEscalationAppointmentPicker onChange={setMedicalEscalationAppointment} />
    </BaseDispositionConfirmationForm>
  );
};

export default MedicalEscalationConfirmationForm;
